import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import Container from 'components/Misc/Container';
import { Stat } from 'components/Misc/Typography';

const Statistics = () => {
	// Use routers params
	const { id } = useParams();

	// Store request parameters
	const parameters = useMemo(() => ({
		related: 'students:statistics'
	}), []);

	// Store requested grade's students
	const [[stats, progress], collect] = useCollect(`grades/${id}`, parameters);

	// Collect grade's students on mount
	useEffect(() => {
		if (id) (async () => await collect())();
	}, [id, collect]);

	return (
		<Container className="p-4 space-x-4 flex justify-around">
			<Stat amount={stats?.active} description="Aktīvi" progress={progress} />
			<Stat amount={stats?.assigned} description="Pievienoti" progress={progress} />
			<Stat amount={stats?.all} description="Visi" progress={progress} />
		</Container>
	);
};

export default Statistics;